import React from 'react';
import { ArrowRightOutlined, ArrowDownOutlined } from '@ant-design/icons';
import BenchmarkBadge from '../../Marketing/BenchmarkBadge';
import './SAHero.css';

/**
 * SAHero — "One agent that does the whole job." The sub names the category
 * ("AI super agent") in natural copy: the page's SEO target query family
 * (Aug 4 pass). Accent line is solid teal, matched with the integration heroes.
 */
const SAHero = ({ ctaLabel, onPrimary, onSeeHow, ctaNote }) => (
  <section className="sa-hero">
    <div className="sa-hero__glow" aria-hidden="true" />
    <div className="sa-hero__inner">
      <BenchmarkBadge page="super-agents" />
      <h1 className="sa-hero__title aie-display">
        One agent that does
        <br />
        <span className="sa-hero__title-accent">the whole job.</span>
      </h1>
      <p className="sa-hero__sub">
        The AI super agent for chat, coding, co-work, research, and media, all
        powered by world-class deep reasoning. <strong>Not just code. Everything.</strong>
      </p>
      <div className="sa-hero__ctas">
        <button type="button" className="aie-btn aie-btn-primary" onClick={onPrimary}>
          {ctaLabel} <ArrowRightOutlined />
        </button>
        <button type="button" className="aie-btn aie-btn-ghost" onClick={onSeeHow}>
          <ArrowDownOutlined /> See it in action
        </button>
      </div>
      {/* Optional risk-remover line under the CTAs. */}
      {ctaNote && <p className="sa-hero__ctanote">{ctaNote}</p>}
    </div>
  </section>
);

export default SAHero;
